<template>
  <section hidden="true">
    <h2>Learning and Development</h2>
    <p>Share any ongoing learning efforts, such as courses, books, or workshops.</p>
    <p>Mention any new skills or technologies you're currently exploring.</p>
  </section>
</template>

<script>
export default {
  name: 'LearningDevelopmentSection'
}
</script>

<style scoped>
section {
  max-width: 950px;
  margin: 0 auto;
  padding: 20px;
  border-radius: 8px;
  color: var(--white-ish);
}

h2 {
  margin-top: 0;
  text-align: center;
}

p {
  margin: 10px 0;
  text-align: center;
}
</style>